module.exports = __webpack_public_path__ + "img/13.ca2c42c0.png";